/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import utils from '../../../lib/utils';
import SelectBusinessToAuth from './BusinessSelection';
import './index.scss';

export default class CSLogin extends React.Component {
  constructor() {
    super();

    this.state = {
      hasError: false,
      regError: false,
      unsubError: false,
      serverError: false,
      email: '',
      password: '',
      isEmailInvalid: false,
      isPasswordBlank: false,
      isEmailBlank: false,
      business_id: '',
      isBusinessIdBlank: false,
      showSelection: false,
    };

    this.onLoginFormSubmit = this.onLoginFormSubmit.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onBusinessIdChange = this.onBusinessIdChange.bind(this);
    this.hideSelectBusiness = this.hideSelectBusiness.bind(this);
  }

  componentDidMount() {
    let creds = [];
    let q = window.location.hash.split('?')[1];
    let token = '';
    if (q != undefined) {
      token = q.split('=')[1];
      creds = atob(token).split(':');
      this.setState({
        email: creds[0],
        password: creds[1],
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.isLoginFail && !this.props.auth.isLoginFail) {
      this.setState({
        hasError: true,
        regError: false,
        serverError: false,
        unsubError: false,
      });
    }

    if (nextProps.auth.isUnsubscribed && !this.props.auth.isUnsubscribed) {
      this.setState({
        hasError: false,
        regError: false,
        serverError: false,
        unsubError: true,
      });
    }

    if (nextProps.auth.isNotRegistered && !this.props.auth.isNotRegistered) {
      this.setState({
        hasError: false,
        regError: true,
        serverError: false,
        unsubError: false,
      });
    }

    if (nextProps.auth.isServerError && !this.props.auth.isServerError) {
      this.setState({
        hasError: false,
        regError: false,
        serverError: true,
        unsubError: false,
      });
    }
    
    if (!nextProps.auth.isValidating && nextProps.auth.isValidating !== this.props.auth.isValidating && !nextProps.auth.isValidCSuser) {
      this.setState({
        hasError: true,
        regError: false,
        serverError: false,
        unsubError: false,
      });
    }
    if (!nextProps.auth.isValidating && nextProps.auth.isValidating !== this.props.auth.isValidating && nextProps.auth.isValidCSuser) {
      this.setState({
        showSelection: true,
        hasError: false,
        regError: false,
        serverError: false,
        unsubError: false,
      })
    }
  }

  onEmailChange(event) {
    this.setState(
      {
        email: utils.sanitizeHTML(event.target.value),
      },
      this.resetValidation,
    );
  }

  onPasswordChange(event) {
    this.setState(
      {
        password: event.target.value,
      },
      this.resetValidation,
    );
  }

  onBusinessIdChange(event) {
    this.setState(
      {
        business_id: event.target.value,
      },
      this.resetValidation,
    );
  }

  onLoginFormSubmit(event) {
    event.preventDefault();

    if (this.validate()) {
      this.props.postLogin({
        email: this.state.email,
        password: this.state.password,
        business_id: this.state.business_id,
      });
    }
  }

  validate() {
    const isValid =
      this.state.email &&
      this.state.password &&
      this.state.business_id &&
      utils.isValidEmail(this.state.email);
    this.setState({
      isEmailInvalid: !utils.isValidEmail(this.state.email),
      isPasswordBlank: !this.state.password,
      isEmailBlank: !this.state.email,
      isBusinessIdBlank: !this.state.business_id,
    });

    return isValid;
  }

  resetValidation() {
    this.setState({
      isEmailInvalid: false,
      isPasswordBlank: false,
      isEmailBlank: false,
      isBusinessIdBlank: false,
    });
  }

  hideSelectBusiness() {
    this.setState({
      showSelection: false,
    })
  }
  
  showSelectBusiness = (event) => {
    event.preventDefault();
    // this.setState({
    //   showSelection: true,
    // })
    this.props.validateUser({
      email: this.state.email,
      password: this.state.password,
    });
  }
  
  clickSignIn = (business) => {
    this.setState({
      showSelection: false,
      business_id: business.value,
    }, () => {
      if (this.validate()) {
        this.props.postLogin({
          email: this.state.email,
          password: this.state.password,
          business_id: this.state.business_id,
        });
      } })
  }
  render() {
    const { showSelection, email, password } = this.state;
    let errorMessage = '';
    let showErrorMessage = false;
    if (this.state.hasError) {
      errorMessage = 'Sorry! Your username/password do not match.';
      showErrorMessage = true;
    } else if (this.state.unsubError) {
      errorMessage = (
        <span>
          {/* Your account has been unsubscribed. */}
          {this.props.auth.errorMessage}
          <br />
          Contact us on{' '}
          <a href="mailto:support@truelark.com">support@truelark.com</a> if you
          would like to reconnect.
        </span>
      );
      showErrorMessage = true;
    } else if (this.state.regError) {
      errorMessage = (
        <span>
          Sorry! You are not a registered member.
        </span>
      );
      showErrorMessage = true;
    } else if (this.state.serverError) {
      errorMessage = 'Service temporarily down. Please try again later.';
      showErrorMessage = true;
    } else if (this.state.isEmailBlank) {
      errorMessage = 'Email cannot be blank';
      showErrorMessage = true;
    } else if (this.state.isEmailInvalid) {
      errorMessage = 'Please enter a valid email id';
      showErrorMessage = true;
    } else if (this.state.isPasswordBlank) {
      errorMessage = 'Password cannot be blank';
      showErrorMessage = true;
    } else if (this.state.isBusinessIdBlank) {
      errorMessage = 'Business ID cannot be blank';
      showErrorMessage = true;
    }
    return (
      <div className="auth-login">
        <div className="auth-login__container">
          <h4>Log in to TrueLark</h4>
          {showErrorMessage ? (
            <div className="message message--error">{errorMessage}</div>
          ) : (
            undefined
          )}
          <form onSubmit={this.showSelectBusiness}>
            <div className="form-group">
              <label htmlFor="email">BUSINESS EMAIL</label>
              <input
                type="text"
                name="email"
                value={this.state.email}
                onChange={this.onEmailChange}
                className={classnames({
                  'has-error':
                    this.state.isEmailBlank || this.state.isEmailInvalid,
                })}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">PASSWORD</label>
              <div className="password-field">
                <input
                  type="password"
                  name="password"
                  value={this.state.password}
                  onChange={this.onPasswordChange}
                  className={classnames({
                    'has-error': this.state.isPasswordBlank,
                  })}
                />
                <NavLink to="/forgot-password" className="forgot-password">
                  Forgot Password?
                </NavLink>
              </div>
            </div>
            <div className="form-group">
              <button
                type="submit"
                className="btn btn--primary btn--lg"
                disabled={this.state.email.length<1 || this.state.password.length<1 || this.props.auth.isLoggingIn}
              >
                {this.props.auth.isLoggingIn ? 'LOGGING IN...' : 'NEXT'}
              </button>
            </div>
          </form>
          <SelectBusinessToAuth modelopen={showSelection} hideSelectBusiness={this.hideSelectBusiness} email={email} password={password} clickSignIn={this.clickSignIn} {...this.props} />
          {/* <div className="auth-login__container__sign-up">
            New to TrueLark? <NavLink to="/signup">Create Account</NavLink>
          </div> */}
        </div>
      </div>
    );
  }
}

CSLogin.defaultProps = {
  postLogin: () => { },
  auth: {
    isLoggingIn: false,
    isLoginFail: false,
    isNotRegistered: false,
    isServerError: false,
    isUnsubscribed: false,
  },
};

CSLogin.propTypes = {
  postLogin: PropTypes.func,
  auth: PropTypes.shape({
    isLoggingIn: PropTypes.bool,
    isLoginFail: PropTypes.bool,
    isNotRegistered: PropTypes.bool,
    isServerError: PropTypes.bool,
    isUnsubscribed: PropTypes.bool,
  }),
};
